export const Portal = {
    baseStyle: {
        width: "100%",
        height: "100%",
        color: "red",
        backgroundColor: "blue"
    }
};
